/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, May 2022
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';
import classes from './Card.module.css';

const Card = props => {
  const {
    active,
    flexBasis,
    section,
    employee,
    onClick,
    isEmployee,
    isAssigned,
    revenueCentersMap,
  } = props;

  const clickHandler = () => {
    onClick && onClick(isEmployee ? employee : section);
  };

  const styles = {
    borderColor: active ? '#ad0028' : '#FFF',
    width: flexBasis,
    backgroundColor: isAssigned ? '#d3d3d3' : '#FFF',
  };

  return (
    <div
      onClick={clickHandler}
      className={classes.container}
      style={styles}>
      {isEmployee
        ? <EmployeeCard employee={employee} />
        : <SectionCard section={section} revenueCentersMap={revenueCentersMap} />
      }
    </div >
  );
};

export default Card;

Card.propTypes = {
  active: PropTypes.bool.isRequired,
  flexBasis: PropTypes.any,
  onClick: PropTypes.func.isRequired,
  section: PropTypes.object,
  employee: PropTypes.object,
  isAssigned: PropTypes.bool,
  revenueCentersMap: PropTypes.instanceOf(Map),
  isEmployee: PropTypes.bool,
};

Card.defaultProps = {
  active: false,
  flexBasis: '30%',
  onClick: () => { },
  section: {},
  employee: {},
  isAssigned: false,
  revenueCentersMap: new Map(),
  isEmployee: false,
};

const EmployeeCard = ({ employee }) => {
  const { posId, firstName, lastName } = employee || {};
  return (
    <div className={classes.innerContainer}>
      <span className={classes.name}>{posId}</span>
      <span className={classes.name}>{lastName},</span>
      <span className={classes.name}>{firstName}</span>
    </div>
  );
};

EmployeeCard.propTypes = {
  employee: PropTypes.object.isRequired,
};

EmployeeCard.defaultProps = {
  employee: {},
};

const SectionCard = ({ section, revenueCentersMap }) => {
  const { name, revenueCenterId } = section || {};
  const revenueCenterName = revenueCentersMap.has(revenueCenterId) ? revenueCentersMap.get(revenueCenterId) : '';

  return (
    <div className={classes.innerContainer}>
      <span className={classes.tableNum}>{name}</span>
      {revenueCenterName && <span className={classes.revCenterName}>({revenueCenterName})</span>}
    </div>
  );
};

SectionCard.propTypes = {
  section: PropTypes.object.isRequired,
  revenueCentersMap: PropTypes.instanceOf(Map),
};

SectionCard.defaultProps = {
  section: {},
  revenueCentersMap: new Map(),
};
